import { render, staticRenderFns } from "./connector-template.vue?vue&type=template&id=65dc554d&scoped=true"
import script from "./connector-template.vue?vue&type=script&lang=js"
export * from "./connector-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dc554d",
  null
  
)

export default component.exports